module.exports = __webpack_public_path__ + "img/go-money-doc.f33cba47.png";